import {
    apiRequest,
    CuttingCategoryDetail
} from "../../../../../services/adapters/master/cuttingCategoryService"

class CreateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", CuttingCategoryDetail, {
            params: query
        }, true)
    }

}

export default CreateRepository